/**
 * True when the app is rendering the new side navigation. The webserver stamps
 * `data-layout="sidenav"` on `<body>` for side-nav companies (see base.html), which is the
 * same signal `useIsNewNavigation` falls back to. Pages rendered with the main navigation
 * hidden never get the stamp, so this reports legacy there. Returns false server-side and
 * before paint.
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get employeeProfileHref () {
        return employeeProfileHref;
    },
    get isSideNavLayout () {
        return isSideNavLayout;
    }
});
const isSideNavLayout = ()=>typeof document !== "undefined" && document.body?.dataset.layout === "sidenav";
const employeeProfileHref = (employeeId)=>isSideNavLayout() ? `/details/${employeeId}/` : `/user/${employeeId}/`;
